module.exports = __webpack_public_path__ + "img/prize-04.2917f4bd.png";